import { fromJS } from 'immutable';
import {
  VIEW_MODE,
  SORT_BY_TIME,
  USER_TYPE,
  CUSTOMER_TABS,
  CUSTOMER_DETAIL_TABS,
} from 'constants/common';

import * as types from './constants';

const initState = fromJS({
  filters: {
    customerStatus: undefined,
    skip: 0,
    take: 10,
    terms: '',
    companyName: '',
    email: '',
    view: VIEW_MODE.LIST,
    page: 1,
    type: USER_TYPE.CUSTOMER,
    role: undefined,
    tab: CUSTOMER_TABS.WAITING_APPROVAL,
    campaignType: undefined,
    sortBy: '',
    sortDirection: '',
  },
  detailFilters: {
    tab: CUSTOMER_DETAIL_TABS.general_info.key,
    sortBy: '',
    sortDirection: '',
    skip: 0,
    take: 10,
    terms: '',
    status: undefined,
    level: undefined,
  },

  transactionFilters: {
    skip: 0,
    take: 10,
    page: 1,
    terms: '',
    type: undefined,
  },
});

export default (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.UPDATE_FILTERS: {
      return state.set('filters', fromJS(payload));
    }
    case types.UPDATE_DETAIL_FILTERS: {
      return state.set('detailFilters', fromJS(payload));
    }
    case types.UPDATE_TRASACTION_FILTERS: {
      return state.set('transactionFilters', fromJS(payload));
    }
    default:
      return state;
  }
};
